/**
 * Episode Presentational Component
 * View: Displays an episode
 */

require('../styles/bigbox.scss');

import React from 'react';

// var self;

let Bigbox = React.createClass({
    //
    // constructor(props) {
    //   super(props);
    //   self = this;
    // },

    injectScript(options) {
       return {
         __html: `<ins class="adsbygoogle"
            data-ad-client="ca-pub-${options.client}"
            data-ad-slot=${options.slot}
            data-ad-format="auto"></ins>`
       };
    },

    indexAd() {
      if(this.adsbygooglejsLoaded){
        console.log('this.adsbygooglejsLoaded is ', this.adsbygooglejsLoaded);
        (window.adsbygoogle? window.adsbygoogle : []).push({});
      }
    },

    componentWillMount() {
       const scriptTag = document.getElementById('adsbygooglejs');
       this.adsbygooglejsLoaded = false;

       if(!scriptTag){
         const script = document.createElement('script');
         script.src = '//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js';
         script.async = true;
         script.onload = this.onScriptLoad;
         document.body.appendChild(script);
       }else{
         this.adsbygooglejsLoaded = true;
       }
    },

    onScriptLoad() {
      this.adsbygooglejsLoaded = true;
      this.indexAd();
    },

    componentDidMount() {
        // this.indexAd();
    },

    componentDidUpdate() {
        // this.indexAd();
    },

    render(){
      return (
        <div className="bigbox"  dangerouslySetInnerHTML={this.injectScript(this.props)} />
      )
    }
});

Bigbox.propTypes = {
  slot: React.PropTypes.number,
  client: React.PropTypes.number
};

Bigbox.defaultProps = {
  slot: 7234815487,
  client: 8689860186813016
};


export default Bigbox;



// WEBPACK FOOTER //
// ./src/components/Bigbox.js